// @Vendor
const React = require('react');

// @core
const { FormattedText } = require('core/i18n').i18n;

// @constants
const { mortgageProductCatalogIdentifiers, afiMortgageProductTypes } = require('constants/mortgageRequestPreApproval');

const { PERCENTAGE_SYMBOL } = require('constants/index');

const hasCollectiveBenefits = (productCatalog) => {
    const collectiveBenefits = productCatalog.find(product => product.get('identificador') !== mortgageProductCatalogIdentifiers.DEFAULT);
    return (collectiveBenefits) ? collectiveBenefits.toJS() : false;
}

const getCollectiveMortgageProductMessage = (mortgageType, defaultMortgageData, collectiveMortgageData, value, className) => {
    if (afiMortgageProductTypes.FIJO === mortgageType) {
        return (
            <FormattedText
                injectedStrings={[`<strong>${defaultMortgageData.tin}${PERCENTAGE_SYMBOL}<strong>`,
                `${collectiveMortgageData.tin}${PERCENTAGE_SYMBOL}`,
                `${defaultMortgageData.tae}${PERCENTAGE_SYMBOL}`,
                `${collectiveMortgageData.tae}${PERCENTAGE_SYMBOL}`]}
                value={value[0]}
                className={className}
            />);
    } else if (afiMortgageProductTypes.VARIABLE === mortgageType) {
        return (
            <FormattedText
                injectedStrings={[`<strong>${collectiveMortgageData.tin}${PERCENTAGE_SYMBOL}<strong>`,
                `${defaultMortgageData.tae}${PERCENTAGE_SYMBOL}`,
                `${collectiveMortgageData.tae}${PERCENTAGE_SYMBOL}`]}
                value={value[0]}
                className={className}
            />);
    } else {
        return (<span>
            <FormattedText
                injectedStrings={[`${defaultMortgageData.tin}${PERCENTAGE_SYMBOL}`,
                `${collectiveMortgageData.tin}${PERCENTAGE_SYMBOL}`]}
                value={value[0]}
                className={className}
            />

            <div>
                <FormattedText
                    injectedStrings={[`<strong>${collectiveMortgageData.tin}${PERCENTAGE_SYMBOL}<strong>`,
                    `${defaultMortgageData.tae}${PERCENTAGE_SYMBOL}`,
                    `${collectiveMortgageData.tae}${PERCENTAGE_SYMBOL}`]}
                    value={value[1]}
                    className={className}
                />
            </div>
        </span>);
    }
}

module.exports = {
    hasCollectiveBenefits,
    getCollectiveMortgageProductMessage
}
